import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { NodeOrGlobalSelect } from "components/inputs";
import { ConfigurationForm } from "components/configurationforms";
import HideOnCloud from "util/conditional/HideOnCloud";
import AppConfig from "util/AppConfig";
import { Alert } from "components/bootstrap";
const InputForm = ({
  globalValue = true,
  configFields,
  nodeValue = void 0,
  titleValue = void 0,
  title,
  typeName,
  description = void 0,
  includeTitleField = void 0,
  handleSubmit,
  values = void 0,
  setShowModal,
  submitButtonText
}) => {
  const [global, setGlobal] = useState(globalValue != null ? globalValue : true);
  const [node, setNode] = useState(nodeValue);
  const configFormRef = useRef(null);
  useEffect(() => {
    var _a;
    (_a = configFormRef.current) == null ? void 0 : _a.open();
  }, []);
  const handleChange = (type, value) => {
    if (type === "node") {
      setNode(value);
    }
    if (type === "global") {
      setGlobal(value);
    }
  };
  const onSubmit = (data) => {
    const newData = {
      ...data,
      ...{
        global: AppConfig.isCloud() || AppConfig.globalInputsOnly() || global,
        node
      }
    };
    handleSubmit(newData);
    setShowModal(false);
  };
  const onCancel = () => {
    setShowModal(false);
  };
  const getValues = () => {
    if (values) {
      return values;
    }
    if (configFormRef.current) {
      return configFormRef.current.getValue().configuration;
    }
    return {};
  };
  const getTitleValue = () => {
    if (titleValue) {
      return titleValue;
    }
    if (configFormRef.current) {
      return configFormRef.current.getValue().titleValue;
    }
    return "";
  };
  const formValues = getValues();
  const formTitleValue = getTitleValue();
  return /* @__PURE__ */ React.createElement(
    ConfigurationForm,
    {
      ref: configFormRef,
      configFields,
      includeTitleField,
      title,
      values: formValues,
      titleValue: formTitleValue,
      submitButtonText,
      submitAction: onSubmit,
      typeName,
      cancelAction: onCancel
    },
    description && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, description),
    /* @__PURE__ */ React.createElement(HideOnCloud, null, !AppConfig.globalInputsOnly() && /* @__PURE__ */ React.createElement(NodeOrGlobalSelect, { onChange: handleChange, global, node }))
  );
};
export default InputForm;
